import constants from './constants';

function setDeviceTypeIdEdit(values) {

  return (dispatch) => {

    dispatch({
      type: constants.SET_IS_EDIT_DEFAULT,
      payload: values,
    });

  };

}

function setCreateEditValues(values) {

  return {
    type: constants.SET_CREATE_EDIT_VALUES,
    payload: values,
  };

}

function changeGroupMapValuesGroupMaps(index, id, value) {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    if (createEditValues) {

      const { maps } = createEditValues;

      const auxMaps = [...maps];
      auxMaps[index][id] = value;
      const newMaps = [...auxMaps];

      const newCreateEditValues = { ...createEditValues, maps: newMaps };

      dispatch({
        type: constants.ADD_CREATE_EDIT_VALUES_GROUP_MAPS,
        payload: newCreateEditValues,
      });

    }

  };

}

function addCreateEditValuesGroupMaps() {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    if (createEditValues) {

      const defaultData = {
        modbus_name: '',
        modbus_function: '',
        modbus_direction: '',
        factor_to_multiply: '',
        modbus_size: '',
        datatypes: '',
      };
      const { maps } = createEditValues;

      let newMaps;
      if (maps?.length > 0) {

        newMaps = [...maps, defaultData];

      } else {

        newMaps = [defaultData];

      }

      const newCreateEditValues = { ...createEditValues, maps: newMaps };

      dispatch({
        type: constants.ADD_CREATE_EDIT_VALUES_GROUP_MAPS,
        payload: newCreateEditValues,
      });

    }

  };

}

function removeCreateEditValuesGroupMaps(index) {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    const { maps } = createEditValues;
    if (maps === undefined) return;

    const newMaps = [...maps];
    newMaps.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, maps: newMaps };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_GROUP_MAPS,
      payload: newCreateEditValues,
    });

  };

}

function changeGroupMapValuesGroupVariables(index, id, value) {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    if (createEditValues) {

      const { variables } = createEditValues;

      const auxVariables = [...variables];
      auxVariables[index][id] = value;
      const newVariables = [...auxVariables];

      const newCreateEditValues = { ...createEditValues, variables: newVariables };

      dispatch({
        type: constants.ADD_CREATE_EDIT_VALUES_GROUP_VARIABLES,
        payload: newCreateEditValues,
      });

    }

  };

}

function addCreateEditValuesGroupVariables() {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    if (createEditValues) {

      const defaultData = {
        variable_name: '',
        variable_key: '',
        variable_modbus_map: '',
        variable_descriptor: '',
      };
      const { variables } = createEditValues;

      let newVariables;
      if (variables?.length > 0) {

        newVariables = [...variables, defaultData];

      } else {

        newVariables = [defaultData];

      }
      const newCreateEditValues = { ...createEditValues, variables: newVariables };

      dispatch({
        type: constants.ADD_CREATE_EDIT_VALUES_GROUP_VARIABLES,
        payload: newCreateEditValues,
      });

    }

  };

}

function removeCreateEditValuesGroupVariables(index) {

  return (dispatch, getState) => {

    const {
      modbusMaps: { createEditValues },
    } = getState();

    const { variables } = createEditValues;
    if (variables === undefined) return;

    const newVariables = [...variables];
    newVariables.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, variables: newVariables };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_GROUP_VARIABLES,
      payload: newCreateEditValues,
    });

  };

}

export default {
  setDeviceTypeIdEdit,
  setCreateEditValues,
  addCreateEditValuesGroupMaps,
  removeCreateEditValuesGroupMaps,
  changeGroupMapValuesGroupMaps,
  addCreateEditValuesGroupVariables,
  removeCreateEditValuesGroupVariables,
  changeGroupMapValuesGroupVariables,
};
